<template>
    <div class="ExpertsHub">
        <div class="card-container">
            <div class="expert-cards">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6" v-for="(expert, expert_index) in recommended_experts_list" :key="expert_index">
                        <div v-loading="expert.is_loading">
                            <ExpertHubProfileCard class="cursor-pointer" :style="[ userProfile.id == expert.id ? { pointerEvents: 'none' } : '' ]" :user_details="expert" :display_profile_verified_icons="true" :active_period="active_period"   @goToExpertStore="goToExpertStore(expert)" ></ExpertHubProfileCard>

                            <!-- @followExpert="followExpert(expert_index, expert)" -->
                        </div>
                    </el-col>
                </el-row>

                <NoDataFound style="padding: 0;" v-if="!is_expert_list_loading && !recommended_experts_list.length"></NoDataFound>

                <!-- btn to load more recos -->
                <div class="show-more-tab" v-if="this.number_of_pages > this.page_no && !is_expert_list_loading" @click="loadMoreExperts()">Load more</div>

                <div class="text-center" v-if="is_expert_list_loading">
                    <img src="../assets/images/company/loader.svg" style="height: 80px; width: 80px;">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { serverAddr } from "../networkConfig";
import { filterCallBack } from "../mixins/filter";
import ExpertHubProfileCard from "@/components/ExpertHubProfileCard.vue";
import NoDataFound from "@/components/NoDataFound.vue";
import { EventBus } from "../eventBus";
import CripNotice from 'crip-vue-notice';
import { HelperNetworkCallBack } from "../mixins/Helper";

export default {
    name: 'ExpertsHub',

    mixins: [filterCallBack, HelperNetworkCallBack],

    props: ['active_period'],

    components: {
        ExpertHubProfileCard,
        NoDataFound
    },

    data() {
        return {
            nav_title: 'Experts hub',
            filter_list: [
                // {
                //     title: "Search expert"
                // },
                {
                    title: "Market Participants",
                    filter: [ "Financial Advisor", "Analyst"],
                    filter_type: 'Free',
                    // filter: ["Broker", "Financial Advisor", "Analyst", "Market Expert"],
                },
                // {
                //     title: "Term",
                //     filter_type: 'Free'
                // },
                // {
                //     title: "Rating",
                //     filter_type: 'Free'
                // },
                // {
                //     title: "Market cap",
                //     filter: ["Large Cap", "Mid Cap", "Small Cap"],
                //     filter_type: 'Free'
                // },
            ],
            recommended_experts_list: [],
            filter_obj: {
                filters: [],
                term: "",
                rating: '',
                experts: [],
                comapany_list: [],
                profession: []
            },
            is_expert_list_loading: false,
            is_scroll_enabled: false,
            page_no: 1,
            number_of_pages: null,
            page_per_entries: 8
        }
    },

    watch: {
        active_period(newValue, oldValue){
            this.page_no = 1;
            this.recommended_experts_list = [];
            this.scrollToTop('expert-cards');
            this.getAllExpertList();
        },
    },

    mounted() {
        // emitted filter list from here to HomePageSideBar.vue
        this.$emit('filters', this.filter_list);

        //called api to initially get experts list
        this.getAllExpertList();

        // window.addEventListener('scroll', this.loadMoreExperts());

        EventBus.$on('clearedSelectedFilter', (filter_obj)=>{
            this.page_no = 1;
            this.recommended_experts_list = [];
            this.scrollToTop('expert-cards');
            this.filter_obj = filter_obj;
            this.getAllExpertList();
        })

        EventBus.$on('emitSelectedFilters', (filter_obj)=>{
            this.page_no = 1;
            this.recommended_experts_list = [];
            this.scrollToTop('expert-cards');
            this.filter_obj = filter_obj;
            this.getAllExpertList();
        })
    },

    methods: {
        goToExpertStore(expert){
            // ignored logged in user
            if(this.userProfile.id != expert.id){
                // on selecting expert commited blank obj in store to cleare existing expert details
                this.$store.commit('commitExpertDetails', {});
                this.$router.push({ path: '/expert-store', query: { user_id: expert.id, user: expert.emp_type, name: expert.name }});
            }

            // const Pushwoosh = window.Pushwoosh || [];
            //     Pushwoosh.push(function(api) {
            //     api.postEvent("Someone Viewed Your Profile!", {
            //         "If Someone viewed your profile": true
            //     });
            // });

        },

        loadMoreExperts(){
            this.page_no = this.page_no +1;
            // this.number_of_pages = null;     //to disable load more tab
            this.getAllExpertList();
        },

        // loadMoreExperts () {
        //     window.onscroll = () => {
        //         //checked is window scrolled to bottom
        //         if ((window.innerHeight + window.scrollY) >= document.body.scrollHeight && this.is_scroll_enabled && !this.is_expert_list_loading && this.number_of_pages > this.page_no) {

        //             this.page_no = this.page_no + 1;
        //             this.getAllExpertList();
        //             this.is_scroll_enabled = false;         //disabled scroll to avoid multiple time function call
        //         }
        //     };
        // },

        //api to get all experts list
        getAllExpertList() {
            this.is_expert_list_loading = true;
            serverAddr
                .post("/performers/v1/expert/expert_hub", {
                    page_number: this.page_no,
                    page_per_entries: this.page_per_entries,
                    star_rating: this.filter_obj.rating ? [this.filter_obj.rating] : [],
                    expert_id_list: this.filter_obj.experts,
                    company_id_list: [],
                    profession: this.filter_obj.profession,
                    // duration: (this.filter_obj.term == 'Short term' || this.filter_obj.term == 'All') ? ["Week", "Month", "Quarter", "Long_term"] : this.filter_obj.term == 'Long term' ? ["Long_term"] : ["Week", "Month", "Quarter", "Long_term"],
                    ranking_by: this.active_period == '1Y' ? "annual_roi" : 'absolute_roi',
                    filter: this.filter_obj.filters,
                    sector: "",
                    stock_id: "",
                    period: this.active_period ? this.active_period : '1M'
                })
                .then((response) =>{
                    if(response.data.status){
                        this.number_of_pages = response.data.pagination.total_pages;
                        this.page_no = response.data.pagination.current_page;

                        response.data.data.forEach((e) =>{
                            let obj = {
                                profile_pic: e.pic ? '/Media/' + e.pic : '',
                                name: e.full_name,
                                rank: e.rank,
                                profession: e.profession,
                                company: e.user_company_name,
                                success_rate: e.success_rate,
                                live_reco: e.live_reco,
                                total_reco: e.total_reco,
                                emp_type: e.response_type,
                                id: e.id,
                                is_followed: e.follow_option_enable,
                                is_loading: false,
                                is_public: e.is_public,
                                annualised_roi: e.annual_roi,
                                absolute_roi: e.absolute_roi,
                                mark_as_verified: e.mark_as_verified
                                // performer_rating: e.overall_rating,
                                // portfolio_rating: e.user_rating,
                                // accuracy: e.accuracy,
                                // following: e.following,
                                // follower: e.follower,
                            };

                            this.recommended_experts_list.push(obj);
                        })

                        // this.is_scroll_enabled = true;         //enable scroll for more stocks
                        this.is_expert_list_loading = false;
                    }else{
                        this.is_expert_list_loading = false;
                        this.page_no = 0;           //if api fails then reset to page 0
                        this.number_of_pages = 0;           //if api fails then reset to page 0
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.is_expert_list_loading = false;
                    this.page_no = 0;           //if api fails then reset to page 0
                    this.number_of_pages = 0;           //if api fails then reset to page 0
                });
        },

        //follow expert api
        followExpert(index, emp) {
            // ignored logged in user
            if(this.userProfile.id != emp.id){
                // if response type is company then sent company id other wise user ids
                if(index !=undefined && index != null){
                    let followList = [];
                    let company = [];
                    let obj = {};

                    this.recommended_experts_list[index].is_loading = true;     //enabled loader

                    if(this.recommended_experts_list[index].is_followed){
                        obj.status = false; //if followed
                    }else{
                        obj.status = true; //if not followed
                    }

                    if(emp.emp_type == 'company'){
                        obj.company_id = this.recommended_experts_list[index].id;
                        company.push(obj);
                    }else{
                        obj.user_id = this.recommended_experts_list[index].id;
                        followList.push(obj);
                    }

                    serverAddr
                    .post("/stockants/add-to-favroite/", {
                        favroite: [],
                        followers: followList,
                        company: company
                    })
                    .then(response => {
                        if(response.data.status){

                            if(this.recommended_experts_list[index].is_followed){
                                this.recommended_experts_list[index].is_followed = false; //if already added to follow list
                                new CripNotice({
                                    title: "Success",
                                    description: 'Unfollowed',
                                    type: "success",
                                    duration: 3,
                                });
                            }else{
                                this.recommended_experts_list[index].is_followed = true; //if not added in follow list
                                new CripNotice({
                                    title: "Success",
                                    description: 'Followed',
                                    type: "success",
                                    duration: 3,
                                });
                            }
                        }

                        this.recommended_experts_list[index].is_loading = false;     //disabled loader
                    })
                    .catch(function(error) {
                        console.log(error);
                        this.recommended_experts_list[index].is_loading = false;     //disabled loader
                    });
                }
            }
        }
    },

    computed: {
        //returns stored user profile from local storage
        userProfile() {
            return JSON.parse(localStorage.getItem("profile"));
        },
    },

    beforeDestroy() {
        EventBus.$off();
        // window.removeEventListener('scroll', this.loadMoreExperts());
        // this.is_scroll_enabled = false;
    },
}
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.ExpertsHub{
    min-height: 100vh;
    background-color: $page-background-color;
    padding-bottom: 60px;
    .card-container{
        width: 100%;
        min-height: 100vh;
        box-sizing: border-box;

        .heading{
            font-size: 1.4rem;
            font-weight: 500;
            color: $primary-theme-color;
        }
        .sub-title{
            line-height: 2;
            font-size: 0.7rem;
            font-weight: 500;
            color: #000;
        }
    }
}

@media screen and (max-width: 1283px) {
  .ExpertsHub {
    .card-container, .footer-section {
        width: 100%;
    }
    .card-container {
        padding: 0px 10px 0 10px;
    }
  }
}
</style>

<style lang="scss">
.ExpertsHub .ExpertHubProfileCard .expert-detail-card{
    margin: 10px 0;
}
</style>
